module.exports = __webpack_public_path__ + "img/icon_leaf.30a48d61.svg";